import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

/**
 * Firebase config — публічний за дизайном; контроль доступу в Firestore rules.
 * Відповідність `brewis-backoffice-backend/firestore.rules`.
 */
const firebaseConfig = {
  apiKey: "AIzaSyDwqIovosVNIow4z4duMKopR73Uv4oSWX0",
  authDomain: "brewis-io.firebaseapp.com",
  projectId: "brewis-io",
  storageBucket: "brewis-io.firebasestorage.app",
  messagingSenderId: "1073873933133",
  appId: "1:1073873933133:web:e7812bfc165c6ef241dd04",
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
